import { render } from "./ManageKPIRecord.vue?vue&type=template&id=89ad43e8&scoped=true"
import script from "./ManageKPIRecord.vue?vue&type=script&lang=js"
export * from "./ManageKPIRecord.vue?vue&type=script&lang=js"

import "./ManageKPIRecord.vue?vue&type=style&index=0&id=89ad43e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ad43e8"]])

export default __exports__